// extracted by mini-css-extract-plugin
module.exports = {"heading":"style_heading__1NA_o","content":"style_content__7au_u"};